import { render, staticRenderFns } from "./IconBubbleEnglish.vue?vue&type=template&id=63ffca2a&"
import script from "./IconBubbleEnglish.vue?vue&type=script&lang=js&"
export * from "./IconBubbleEnglish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports